function updateArrows() {
    let $active = $("ul.product__media-list li.product__media-item.is-active");
    let $next = $active.next("li.product__media-item");
    let $prev = $active.prev("li.product__media-item");
  }
  
  $(".product-media-next-arrow-cls").click(function () {
      let $active = $("ul.product__media-list li.product__media-item.is-active");
      let $next = $active.next("li.product__media-item");
  
      if ($next.length) {
          $active.removeClass("is-active");
          $next.addClass("is-active");
      } else {
          $active.removeClass("is-active");
          $("ul.product__media-list li.product__media-item").first().addClass("is-active");
      }
      updateArrows();

      var indx = $(this).parents('ul.product__media-list').find('li.is-active').index();
      $('.thumbnail-list .thumbnail-list__item:eq('+indx+') button').trigger('click');
    
  });

  $(".product-media-prev-arrow-cls").click(function () {
    let $active = $("ul.product__media-list li.product__media-item.is-active");
    let $prev = $active.prev("li.product__media-item");
  
    if ($prev.length) {
        $active.removeClass("is-active");
        $prev.addClass("is-active");
    } else {
        $active.removeClass("is-active");
        $("ul.product__media-list li.product__media-item").last().addClass("is-active");
    }
    updateArrows();
      var indx = $(this).parents('ul.product__media-list').find('li.is-active').index();
      $('.thumbnail-list .thumbnail-list__item:eq('+indx+') button').trigger('click');
  });